import { PUBLIC_NEWS_CACHE_VERSION } from './source-attribution'

/**
 * Kısa yeniden deneme: SSR / Node’da backend geç açılınca ECONNREFUSED olur.
 * Tarayıcıda varsayılan tek deneme (gereksiz gecikme yok).
 */
export async function fetchWithConnectionRetry(
  input: RequestInfo | URL,
  init?: RequestInit,
  options?: { attempts?: number; baseDelayMs?: number },
): Promise<Response> {
  const defaultAttempts = typeof window === 'undefined' ? 4 : 1
  const attempts = options?.attempts ?? defaultAttempts
  const baseDelayMs = options?.baseDelayMs ?? 300
  // A stable server-only header changes Next's fetch key without changing API
  // routing, signatures or browser CORS. Do not reuse pre-privacy news payloads.
  let requestInit = init
  if (typeof window === 'undefined') {
    try {
      const request = typeof Request !== 'undefined' && input instanceof Request ? input : null
      const url = new URL(request ? request.url : String(input), 'http://public-news.invalid')
      const method = (init?.method || request?.method || 'GET').toUpperCase()
      if (method === 'GET' && (/^\/api\/news(?:\/|$)/.test(url.pathname) || /^\/api\/users\/profile\//.test(url.pathname))) {
        const headers = new Headers(init?.headers || request?.headers)
        headers.set('x-haber-public-news-version', PUBLIC_NEWS_CACHE_VERSION)
        requestInit = { ...init, headers }
      }
    } catch {
      // Invalid requests retain the fetch implementation's existing error path.
    }
  }
  let lastError: unknown
  for (let i = 0; i < attempts; i++) {
    try {
      return await fetch(input, requestInit)
    } catch (e) {
      lastError = e
      if (i === attempts - 1) break
      await new Promise((r) => setTimeout(r, baseDelayMs * (i + 1)))
    }
  }
  throw lastError
}
